import { render, staticRenderFns } from "./FeedbackContainer.vue?vue&type=template&id=1ee52864&scoped=true&"
import script from "./FeedbackContainer.vue?vue&type=script&lang=js&"
export * from "./FeedbackContainer.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackContainer.vue?vue&type=style&index=0&id=1ee52864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee52864",
  null
  
)

export default component.exports